import { render, staticRenderFns } from "./noApprove.vue?vue&type=template&id=0294a124&"
import script from "./noApprove.vue?vue&type=script&lang=js&"
export * from "./noApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports